export default __webpack_public_path__ + "static/media/light.fc596a10.svg";